/**
 * 商品页手机吸底 WhatsApp 条的显隐。
 *
 * 状态机抄 assets/sticky-add-to-cart.js(Atelier 原生,已在 LIVE 验证过),只换锚点:
 *   锚点 A = 页内主 CTA .wb-product-cta —— 向上滚出视野后出现,回到视野收起
 *   锚点 B = footer —— 还差 200px 进场就收起,页面尾部不被压住
 * 全站 defer 加载,非商品页第一行就 return。
 *
 * 设计见 docs/decisions/2026-09-19-product-sticky-whatsapp-design.md §4。
 */
(function () {
  var bar = document.querySelector('.wb-sticky-cta');
  if (!bar || !('IntersectionObserver' in window)) return;

  var anchor = document.querySelector('.wb-product-cta');
  var footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
  if (!anchor || !footer) return;

  var stuck = false;
  var hiddenByBottom = false;

  // Shopify Inbox 的 <shopify-chat> 也浮在屏幕下缘,让它优先,不抢位置。
  // 店里当前没装 Inbox,但 chat-drawer.liquid 无条件渲染这个元素,留着成本为零。
  function chatActive() {
    return !!(window.customElements && customElements.get('shopify-chat'));
  }

  function show() {
    if (chatActive()) return;
    stuck = true;
    bar.dataset.stuck = 'true';
    bar.setAttribute('aria-hidden', 'false');
  }

  function hide() {
    stuck = false;
    bar.dataset.stuck = 'false';
    bar.setAttribute('aria-hidden', 'true');
  }

  // 元素在视口「上方」而不是「下方」—— 下方表示还没滚到,不该出条
  function scrolledPast(element) {
    var rect = element.getBoundingClientRect();
    return rect.bottom < 0 || rect.top < 0;
  }

  new IntersectionObserver(function (entries) {
    var entry = entries[0];
    if (!entry) return;

    if (!entry.isIntersecting && !stuck) {
      if (scrolledPast(entry.target)) show();
    } else if (entry.isIntersecting && stuck) {
      hiddenByBottom = false;
      hide();
    }
  }).observe(anchor);

  new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      if (!entry) return;

      if (entry.isIntersecting && stuck) {
        hiddenByBottom = true;
        hide();
      } else if (!entry.isIntersecting && hiddenByBottom) {
        hiddenByBottom = false;
        if (scrolledPast(anchor)) show();
      }
    },
    { rootMargin: '200px 0px 0px 0px' }
  ).observe(footer);

  // Inbox 的 bundle 可能在首次滚动之后才升级 <shopify-chat>,那时条已经出来了,
  // 升级完成后补一次收起(同 Atelier 的做法)。没装 Inbox 时这个 promise 永不 resolve。
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-chat').then(function () {
      if (stuck) hide();
    });
  }
})();
